import { forwardRef, useState } from "react";

interface Props {
  onSend: (text: string) => void;
  disabled?: boolean;
}

export const Composer = forwardRef<HTMLInputElement, Props>(function Composer({ onSend, disabled }, ref) {
  const [value, setValue] = useState("");

  function submit() {
    const t = value.trim();
    if (!t || disabled) return;
    onSend(t);
    setValue("");
  }

  // The placeholder promises only what v1 can do. It used to say "Ask about your
  // inbox, …", but prod has no SHARED_MAILBOX, so the orchestrator can only see the
  // open message and says so when asked about the mailbox. Don't re-add inbox wording
  // here before that config exists.
  return (
    <div className="tp-composer">
      <input
        ref={ref}
        type="text"
        value={value}
        placeholder="Ask about this email or an HR policy…"
        aria-label="Message the assistant"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            submit();
          }
        }}
      />
      <button className="tp-send" title="Send" aria-label="Send message" onClick={submit}>
        <svg viewBox="0 0 20 20" width="16" height="16">
          <path fill="currentColor" d="M2.72 2.05a.75.75 0 0 0-.97.94l2.1 6.26 7.65.75-7.65.75-2.1 6.26a.75.75 0 0 0 .97.94l15-6.25a.75.75 0 0 0 0-1.4l-15-6.25Z" />
        </svg>
      </button>
    </div>
  );
});
